const avtoPathesHead = {
  city: (data, p) => ({
    title: `Дилеры спецтехники для авто ${p.inCity}. Лучшие предложения от автодилеров - АвтоБазар`,
    description: `Дилеры спецтехники ${p.inCity}. Лучшие предложения на спецтехнику от проверенных дилеров ✅ адреса и телефоны компаний ☎️ на сайте АвтоБазар`,
    header: `Дилеры спецтехники ${p.t(data.city)}`,
    title_uk: `Дилери спецтехніки для авто ${p.inCity}. Кращі пропозиції від автодилерів - Автобазар`,
    description_uk: `Дилери спецтехніки ${p.inCity}. Кращі пропозиції на спецтехніку від перевірених дилерів ✅ адреси і телефони компаній ☎️ на сайті Автобазар`,
    header_uk: `Дилери спецтехніки ${p.t(data.city)}`,
  }),
  cityMake: (data, p) => ({
    title: `Дилеры спецтехники ${data.make} ${p.inCity}. Лучшие предложения от автодилеров - АвтоБазар`,
    description: `Дилеры спецтехники ${data.make} ${p.inCity}. Лучшие предложения на спецтехнику ${data.make} от проверенных дилеров ✅ адреса и телефоны компаний ☎️ на сайте АвтоБазар`,
    header: `Дилеры спецтехники ${data.make} ${p.inCity}`,
    title_uk: `Дилери спецтехніки ${data.make} ${p.inCity}. Кращі пропозиції від автодилерів - Автобазар`,
    description_uk: `Дилери спецтехніки ${data.make} ${p.inCity}. Кращі пропозиції на спецтехніку ${data.make} від перевірених дилерів ✅ адреси і телефони компаній ☎️ на сайті Автобазар`,
    header_uk: `Дилери спецтехніки ${data.make} ${p.inCity}`,
  }),
};

export default avtoPathesHead;




// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/spetstehnika/templates.js